import React, { Component } from 'react';
import { Container } from 'reactstrap';

class ContactInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            phone: '',
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        fetch(`${process.env.REACT_APP_API_URL}/api/globals/contact-info`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                this.setState({
                    email: data.email || '',
                    phone: data.phone || '',
                    loading: false,
                });
            })
            .catch((error) => {
                this.setState({ error: error.message, loading: false });
            });
    }

    render() {
        const { email, phone, loading, error } = this.state;

        if (loading) return null;
        if (error) return <p>Error loading contact info: {error}</p>;

        return (
            <div className="sales-banner">
                <Container>
                    <a href={`tel:${phone.replace(/[^+\d]/g, '')}`}>{phone}</a>
                    <a href={`mailto:${email}`}>{email}</a>

                </Container>
            </div>
        );
    }
}

export default ContactInfo;

